import type { InterfaceInputToken } from '@morpho-org/dapp-core'

import { formatUnits } from 'viem'

import { toInterfaceInputToken } from '@/helpers/interfaceToken'

interface TableTokenLabel {
  address: `0x${string}`
  decimals: number
  symbol: string | null
  logoUri: string | null
}

/**
 * The token one of the positions tables renders, priced from its largest row with a USD value: the
 * amount cells choose their digits from the price, and the procedures send amounts and their USD
 * values, not the token price.
 */
export function toTableToken(
  token: TableTokenLabel,
  rows: readonly { amount: string; amountUsd: number | null }[],
  chainId: number
): InterfaceInputToken {
  const priced = rows
    .filter(row => row.amountUsd !== null && row.amountUsd > 0 && BigInt(row.amount) > 0n)
    .reduce<(typeof rows)[number] | undefined>(
      (largest, row) => (!largest || BigInt(row.amount) > BigInt(largest.amount) ? row : largest),
      undefined
    )
  const priceUsd = priced
    ? priced.amountUsd! / Number(formatUnits(BigInt(priced.amount), token.decimals))
    : null
  return toInterfaceInputToken({ ...token, priceUsd }, chainId)
}
